module.exports = __webpack_public_path__ + "img/welcome-icon.bae09143.png";